module.exports = __webpack_public_path__ + "static/media/jeanclaude.1fd302e1.png";